import React from 'react';

const KOALENDAR = 'https://koalendar.com/e/meet-with-mark-bernstein';

const MILESTONES = [
    { year: '1999', title: 'GeoCities → Yahoo!', sub: '$4.3bn exit', dot: '#FC7785' },
    { year: '2021', title: 'Wearable Technologies', sub: 'Sold to Blackline Safety (TSX)', dot: '#FC7785' },
    { year: '2022', title: 'Diligentsia founded', sub: 'Democratising transaction DD', dot: '#FC7785' },
    { year: 'Today', title: '40+ VCs · 700+ investors', sub: "UK's leading readiness platform", dot: '#4A67FF' },
];

const AboutHeroSection = () => (
    <section className="lp-hero">
        <div className="lp-hero-glow lp-glow-anim" aria-hidden="true" />
        <div className="lp-hero-inner">
            <div className="lp-hero-copy">
                <div className="lp-badge" data-lp-reveal><span />Our Story</div>
                <h1 className="lp-h1" data-lp-reveal data-lp-delay="60">Built by people who've<br /><span style={{ color: '#FC7785' }}>been in the room.</span></h1>
                <p className="lp-lead" data-lp-reveal data-lp-delay="120">We spent decades raising capital, completing transactions, and advising growing businesses. We know what breaks deals — and we built Diligentsia to fix it.</p>
                <div className="lp-cta-row" data-lp-reveal data-lp-delay="180">
                    <a className="lp-btn lp-btn--primary" href={KOALENDAR} target="_blank" rel="noopener noreferrer">Book a call with Mark</a>
                    <a className="lp-btn lp-btn--pe-outline" href="#team">Meet the team ↓</a>
                </div>
                <div className="lp-hero-social" data-lp-reveal data-lp-delay="240">
                    <span style={{ width: 8, height: 8, borderRadius: '50%', background: '#FC7785', display: 'inline-block', flex: 'none' }} />
                    30+ years experience · 4 IPOs · 2 unicorns · 25 M&amp;A transactions
                </div>
            </div>

            <div className="lp-hero-art">
                <div className="lp-hero-stage lp-hero-stage--about">
                    <img className="lp-hero-photo" src={require('../../../../images/landing-pages/about-us/about-us-top-banner.png')} alt="Diligentsia team" />
                    <div className="lp-about-milestones lp-float" data-lp-reveal data-lp-delay="200">
                        <div className="ttl">Milestones</div>
                        <div className="list">
                            {MILESTONES.map((m, i) => (
                                <div className="row" key={i}>
                                    <span className="dot" style={{ background: m.dot }} />
                                    <div>
                                        <div className="yr">{m.year}</div>
                                        <div className="t">{m.title}</div>
                                        <div className="s">{m.sub}</div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
);

export default AboutHeroSection;
